import { gql } from '@apollo/client';

export const GET_IS_COOKIE_POLICY_AGREED = gql`
  query GetIsCookiePolicyAgreed {
    user @client {
      isCookiePolicyAgreed
    }
  }
`;
